import StyledBox from './StyledBox';

export default StyledBox;
